import React from 'react';
import {bemClassName} from 'bem-components-connector'


import {setPathForRouter} from "@common-helpers/set-rout-path"
import {Progressbar, startRandomProgress} from '@common-components/progressbar'
import logo from "@common-images/logo.svg";
import Book from "@common-images/book-animation.gif";

import './style.scss'

const AnswersHandling = ({
                             additionalClasses = '',
                             nextRout,
                             nextPageId,
                             title = 'Обработка ваших ответов'
}) => {

    const block = bemClassName('answer-handling'),
          progress = startRandomProgress(setPathForRouter(nextRout, nextPageId), true, 180),
          language = localStorage.getItem('lang')

    if (language === "eng") {
        title = "Processing your responses"
    } else if (language === "fr"){
        title = "Traitement de vos réponses"
    } else if (language === "ger"){
        title = "Umgang mit Ihren Antworten"
    } else if (language === "it"){
        title = "Gestire le tue risposte"
    }

    return (<div className={`content ${additionalClasses} ${block()}`} >

        <div className={block('container')}>

            <img src={logo} alt=""/>

            <img className={block('illustration')} src={Book} alt=""/>
            
            <Progressbar timeout={1000} progress={progress} list={['Предварительная обработка ...']}/>

            <h1 className={block('title')}>{title}</h1>
        </div>


    </div>)
};

export default AnswersHandling;
